"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HandleSkip = exports.HandleChange = exports.GetTestIds = void 0;
var QuizNameMethods = _interopRequireWildcard(require("./QuizNamePanel"));
var _ImportedContentFragment = _interopRequireDefault(require("../ContentFragments/ImportedContentFragment"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _QuizProvider = require("./QuizProvider");
var _classnames = _interopRequireDefault(require("classnames"));
var _function = require("../../utils/type-checks/function");
var _string = require("../../utils/type-checks/string");
var _styles = require("@mui/material/styles");
var _material = require("@mui/material");
var _react = _interopRequireWildcard(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const merge = require("deepmerge"),
  GetTestIds = testId => ({
    actions: (0, _string.isStringOfLength)(testId) ? `${testId}__actions` : undefined,
    description: (0, _string.isStringOfLength)(testId) ? `${testId}__description` : undefined,
    component: (0, _string.isStringOfLength)(testId) ? testId : undefined,
    icon: (0, _string.isStringOfLength)(testId) ? `${testId}__icon` : undefined,
    title: (0, _string.isStringOfLength)(testId) ? `${testId}__title` : undefined
  }),
  HandleChange = (e, dispatch, onChange) => {
    const result = {
      dispatch: false,
      onChange: false
    };
    if ((0, _function.isFunction)(dispatch)) {
      dispatch({
        type: "updateForm",
        name: "firstName",
        value: e.target.value
      });
      result.dispatch = true;
    }
    if ((0, _function.isFunction)(onChange)) {
      onChange(e);
      result.onChange = true;
    }
    return result;
  },
  HandleSkip = (e, dispatch, onSkip) => {
    const result = {
      dispatch: false,
      onSkip: false
    };
    if ((0, _function.isFunction)(dispatch)) {
      dispatch({
        type: "updateForm",
        name: "firstName",
        value: ""
      });
      result.dispatch = true;
    }
    if ((0, _function.isFunction)(onSkip)) {
      onSkip(e);
      result.onSkip = true;
    }
    return result;
  };

/**
 * Quiz Modal Panel - User Name
 *
 * @visibleName Quiz Name Panel
 * @author [Jeff Stevens](mailto:jeffrey.stevens@pheaa.org)
*/
exports.HandleSkip = HandleSkip;
exports.HandleChange = HandleChange;
exports.GetTestIds = GetTestIds;
const QuizNamePanel = props => {
  const {
      altText = "Person Icon",
      children,
      className,
      customActions,
      customTheme = {},
      defaultValue = "",
      description = "This is recommended if you are printing your results for a classroom activity.",
      descriptionTag = "p",
      disableNext = false,
      fragmentId,
      hideActions = false,
      hideButton = false,
      hideDescription = false,
      hideIcon = false,
      hideSkip = false,
      hideTitle = false,
      icon = "data:image/svg+xml;base64,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",
      labelText = "Enter first name here...",
      navigateButtonText = "View Results",
      navigateButtonVariant = "primary",
      onChange,
      onNavigateForward,
      onSkip,
      skipButtonText = "Skip",
      skipButtonVariant = "ctalink",
      styles = {},
      testId,
      title = "Enter your name to see your results!",
      titleTag = "h2"
    } = props,
    quizTheme = _QuizProvider.Methods.useCustomTheme(),
    theme = merge.all([(0, _styles.useTheme)(), quizTheme, customTheme]),
    state = _QuizProvider.Methods.useState(),
    dispatch = _QuizProvider.Methods.useDispatch(),
    customClassNames = (0, _classnames.default)({
      "quiz__modal-panel": true,
      "quiz__modal-panel--isNamePanel": true,
      [`${className}`]: className
    }),
    customStyles = merge({
      ".quiz__modal-panel-content": {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        ".heading--isInteriorPageSubHeading": {
          color: theme.quiz.namePanel.headingColor,
          fontSize: "2.8rem",
          marginTop: "1.4rem"
        },
        "input": {
          textAlign: "left"
        }
      },
      ".quiz__modal-panel-user-field": {
        marginTop: "2.9rem",
        maxHeight: "4.2rem",
        width: {
          xs: "calc(100% - 5rem)",
          md: "calc(100% - 22rem)"
        },
        ".MuiInput-root": {
          width: "100%"
        }
      },
      ".quiz__modal-panel-actions": {
        display: "flex",
        flexDirection: "row-reverse",
        justifyContent: "flex-start",
        marginTop: "5.6rem",
        ".MuiButton-root": {
          minWidth: "unset",
          padding: {
            xs: "0.9rem 2rem",
            md: "1.3rem 2rem"
          }
        }
      },
      ".quiz__modal-panel-button--isSkip": {
        fontSize: "1.8rem"
      }
    }, styles),
    testIdObject = QuizNameMethods.GetTestIds(testId),
    handleChange = e => QuizNameMethods.HandleChange(e, dispatch, onChange),
    handleSkip = e => QuizNameMethods.HandleSkip(e, dispatch, onSkip);
  (0, _react.useEffect)(() => {
    if (defaultValue) {
      dispatch({
        type: "updateForm",
        name: "firstName",
        value: defaultValue
      });
    }
  }, [defaultValue, dispatch]);
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: customClassNames,
    "data-testid": testIdObject.component,
    sx: customStyles
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "quiz__modal-panel-content"
  }, !hideIcon && icon && (0, _string.isStringOfLength)(icon) && /*#__PURE__*/_react.default.createElement("img", {
    src: icon,
    alt: altText,
    "data-testid": testIdObject.icon
  }), !hideIcon && icon && !(0, _string.isStringOfLength)(icon) && /*#__PURE__*/_react.default.createElement(_material.Box, {
    component: "div",
    "data-testid": testIdObject.icon
  }, icon), !hideTitle && title && (0, _string.isStringOfLength)(title) && /*#__PURE__*/_react.default.createElement(_material.Typography, {
    component: titleTag,
    className: "heading--isInteriorPageSubHeading",
    "data-testid": testIdObject.title
  }, title), !hideTitle && title && !(0, _string.isStringOfLength)(title) && /*#__PURE__*/_react.default.createElement(_material.Box, {
    component: "div",
    "data-testid": testIdObject.title
  }, title), !hideDescription && description && (0, _string.isStringOfLength)(description) && /*#__PURE__*/_react.default.createElement(_material.Typography, {
    component: descriptionTag,
    "data-testid": testIdObject.description
  }, description), !hideDescription && description && !(0, _string.isStringOfLength)(description) && /*#__PURE__*/_react.default.createElement(_material.Box, {
    component: "div",
    "data-testid": testIdObject.description
  }, description), fragmentId && /*#__PURE__*/_react.default.createElement(_ImportedContentFragment.default, {
    id: fragmentId
  }), children, /*#__PURE__*/_react.default.createElement(_material.TextField, {
    className: "quiz__modal-panel-user-field",
    id: "firstName",
    label: labelText,
    name: "firstName",
    variant: "standard",
    inputProps: {
      autoFocus: true
    },
    value: state.formState.firstName,
    onChange: handleChange
  })), !hideActions && /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "quiz__modal-panel-actions",
    "data-testid": testIdObject.actions
  }, !hideButton && /*#__PURE__*/_react.default.createElement(_material.Button, {
    className: "quiz__modal-panel-button quiz__modal-panel-button--isNext",
    disabled: disableNext,
    onClick: onNavigateForward,
    variant: navigateButtonVariant
  }, navigateButtonText), !hideSkip && /*#__PURE__*/_react.default.createElement(_material.Button, {
    className: "quiz__modal-panel-button quiz__modal-panel-button--isSkip",
    onClick: handleSkip,
    variant: skipButtonVariant
  }, skipButtonText), customActions && /*#__PURE__*/_react.default.createElement(_react.Fragment, null, customActions)));
};

// Define propTypes;
QuizNamePanel.propTypes = {
  /** Alt. Text for Person Icon (Default Value: "Person Icon") */
  altText: _propTypes.default.string,
  /** Children nodes to include */
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
  /** Custom classnames */
  className: _propTypes.default.string,
  /** Custom Actions Component */
  customActions: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
  /** Custom Theme Object (Default Value: {}) */
  customTheme: _propTypes.default.object,
  /** Default user name value (Default Value: "") */
  defaultValue: _propTypes.default.string,
  /** String or component for description text (Default Value: "This is recommended if you are printing your results for a classroom activity.") */
  description: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  /** String for description HTML tag (Default Value: "p") */
  descriptionTag: _propTypes.default.string,
  /** Boolean to disable next button (Default Value: false) */
  disableNext: _propTypes.default.bool,
  /** Fragment ID */
  fragmentId: _propTypes.default.string,
  /** Boolean to hide default actions block (Default Value: false) */
  hideActions: _propTypes.default.bool,
  /** Boolean to hide default button (Default Value: false) */
  hideButton: _propTypes.default.bool,
  /** Boolean to hide description (Default Value: false) */
  hideDescription: _propTypes.default.bool,
  /** Boolean to hide icon (Default Value: false) */
  hideIcon: _propTypes.default.bool,
  /** Boolean to show/hide skip button (Default Value: false) */
  hideSkip: _propTypes.default.bool,
  /** Boolean to hide title (Default Value: false) */
  hideTitle: _propTypes.default.bool,
  /** String or component for icon (Default Value: Base 64 SVG String) */
  icon: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  /** Label Text for User Name field (Default Value: "Enter first name here...") */
  labelText: _propTypes.default.string,
  /** Custom navigate button text (Default Value: "View Results") */
  navigateButtonText: _propTypes.default.string,
  /** Navigation button variant (Default Value: "primary") */
  navigateButtonVariant: _propTypes.default.string,
  /** Custom function to call on name value change */
  onChange: _propTypes.default.func,
  /** Custom function to call when navigating forward */
  onNavigateForward: _propTypes.default.func.isRequired,
  /** Custom function to call when skipping panel */
  onSkip: _propTypes.default.func.isRequired,
  /** Custom Skip Button Text (Default Value: "Skip") */
  skipButtonText: _propTypes.default.string,
  /** Skip Button variant (Default Value: "ctalink") */
  skipButtonVariant: _propTypes.default.string,
  /** Custom styles object (Default Value: {}) */
  styles: _propTypes.default.object,
  /** String or component for title (Default Value: "Enter your name to see your results!") */
  title: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  /** String for title HTML tag (Default Value: "h2") */
  titleTag: _propTypes.default.string,
  /** @ignore */
  testId: _propTypes.default.string
};

// Export component as default;
var _default = exports.default = QuizNamePanel;